<script setup lang="ts">
import { RouterLink, type RouteLocationRaw } from 'vue-router'

withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'ghost'
    size?: 'sm' | 'md'
    disabled?: boolean
    type?: 'button' | 'submit' | 'reset'
    to?: RouteLocationRaw
  }>(),
  { variant: 'secondary', size: 'md', disabled: false, type: 'button', to: undefined }
)
</script>

<template>
  <component
    :is="to && !disabled ? RouterLink : 'button'"
    :to="to && !disabled ? to : undefined"
    :type="to && !disabled ? undefined : type"
    :disabled="disabled || undefined"
    class="pf-button"
    :class="[`pf-button--${variant}`, `pf-button--${size}`]"
  >
    <slot />
  </component>
</template>
